<template>
    <div class="modal-backdrop">
        <div class="modal-content">
            <!-- Header -->
            <div class="modal-header">
                <h2>Registro de Rosto</h2>
                <button @click="cancelRegistration" class="close-btn">&times;</button>
            </div>

            <!-- Corpo do Modal -->
            <div class="modal-body" v-if="!photoStep">
                <h1 class="message-p">Ao fazer o registro de um rosto, o registro anterior será substituído.</h1>
                <div class="modal-container">
                    <input class="hidden-input" type="text" autocomplete="off" id="barcodeinput" v-model="barCodeInput">
                    <div class="form" :class="{ 'lockKeyboardCons': lockKeyboardCons }">
                        <div class="config-item" :class="{ 'distance-bottom': !lockKeyboardCons }">
                            <div class="label-container"
                                :class="{ 'disabled-label': loggedSuccessfully || changeConsumerFor !== '' }">
                                <label for="consumer" v-text="getString('consumidor')"></label>
                            </div>
                            <div id="consumer" ref="consumerDiv" class="div-input-android"
                                :class="{ 'active-input': isTheActiveInput('consumerDiv'), 'disabled-input': loggedSuccessfully }"
                                @click="switchActiveInput('consumerDiv')">
                            </div>
                        </div>

                        <div class="config-item" v-if="!lockKeyboardCons">
                            <div class="label-container" :class="{ 'disabled-label': loggedSuccessfully }">
                                <label for="password" v-text="getString('senha')"></label>
                            </div>
                            <div id="password" ref="passwordDiv" class="div-input-android"
                                :class="{ 'active-input': isTheActiveInput('passwordDiv'), 'disabled-input': loggedSuccessfully }"
                                @click="switchActiveInput('passwordDiv')">
                            </div>
                        </div>
                    </div>

                    <div class="barcode-info" v-if="lockKeyboardCons && !loggedSuccessfully">
                        <img :src="imgBarCode" />
                        <p v-text="getString('bar_code_cracha')"></p>
                    </div>

                    <AndroidKeyboard id="android-keyboard"
                        v-if="!loggedSuccessfully && !lockKeyboardCons"
                        :inputElement="inputElement" :layout="layout" :isPasswordField="isPasswordField"
                        @passwordCharacterTyped="passwordCharacterTyped"
                        @passwordCharacterErased="passwordCharacterErased" @passwordFieldCleaned="passwordFieldCleaned">
                    </AndroidKeyboard>
                </div>
            </div>

            <div class="modal-body" v-if="photoStep">
                <h1 class="message-p" v-if="selectedUserName">{{ selectedUserName }}</h1>

                <div class="camera" v-if="!photo">
                    <video ref="cameraVideo" autoplay></video>
                </div>

                <div v-if="photo" class="photo-preview">
                    <h1 class="message-p">Pré-visualização da Foto</h1>
                    <img :src="photo" alt="Foto capturada" />
                    <DefaultButton :text="'Refazer Foto'" @defaultBtnClick="retakePhoto" />
                </div>

                <DefaultButton v-if="!photo" :text="'Tirar Foto'" @defaultBtnClick="capturePhoto" />
            </div>

            <div class="modal-footer">
                <DefaultButton :text="getString('Cancelar')" @defaultBtnClick="cancelRegistration" layoutGom="true"
                    outlined="true" />
                <DefaultButton v-if="controlsEnabled && !loggedSuccessfully && !photoStep" :text="getString('confirmar')"
                    @defaultBtnClick="loginConsumer()"></DefaultButton>
                <DefaultButton v-if="photoStep" :disabled="!photo" :text="'Salvar'" @defaultBtnClick="savePhoto" />
            </div>
        </div>
    </div>
</template>

<script>
import md5 from 'md5'
import axios from 'axios'
import DefaultButton from '@/components/DefaultButton'
import LocaleController from '@/assets/controllers/LocaleController'
import eventModule from '@/assets/libs/eventModule'
import Util from '@/assets/libs/util'
import CameraController from '@/assets/controllers/CameraController'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import requestModule from '@/assets/libs/requestModule'

const {
    linkApi: API_HOST,
    colectionCode: COLLECTION_CODE
} = Util.getFaceRecognitionParams()

export default {
    components: {
        DefaultButton,
        AndroidKeyboard
    },
    props: {
        isModalVisible: Boolean
    },
    data () {
        return {
            selectedUserName: '',
            photo: null,
            stream: null,
            photoStep: false,
            loggedSuccessfully: false,
            lockKeyboardCons: Util.isLockKeyboardCons(),
            imgBarCode: require('../../static/icons/ic-codigo-barras.png'),
            controlsEnabled: true,
            changeConsumerFor: '',
            barCodeInput: '',
            rawConsumer: null,
            rawPassword: '',
            consumer: '',
            password: '',
            consumerId: null,
            consumerName: '',
            clientCode: null,
            consumerCode: null,
            clientName: '',
            consumerLogin: '',
            inputElement: null,
            isPasswordField: false,
            layout: keyboardLayout.LOGIN_AND_PASSWORD,
            images: [],
            ignoreQrCodeSk: Util.getLocalConfigs('ignoreQrCode') || false
        }
    },
    watch: {
        isModalVisible (newValue) {
            eventModule.$emit('update:pauseDetection', newValue)
            if (!newValue) {
                this.resetRegistration()
            }
        }
    },
    mounted () {
        this.inputElement = this.$refs.consumerDiv
        console.log(API_HOST)
        if (this.changeConsumerFor !== '') {
            this.rawConsumer = this.changeConsumerFor
        }

        this.startBarcode()
    },
    methods: {
        getString (key) {
            return LocaleController.getString(key)
        },
        async startCamera () {
            if (!Util.isAndroidMode()) {
                const faceCameraId = await CameraController.getCameraDeviceForScreen('face')
                if (navigator.mediaDevices && faceCameraId) {
                    try {
                        this.stream = await navigator.mediaDevices.getUserMedia({
                            video: {
                                deviceId: { exact: faceCameraId }, // Especifica a câmera do "face"
                                width: 720,
                                height: 720,
                                frameRate: { ideal: 24, max: 24 }
                            }
                        })
                        const video = this.$refs.cameraVideo
                        if (video) video.srcObject = this.stream
                    } catch (error) {
                        console.error('Erro ao acessar a câmera:', error)
                    }
                }
            } else {
                window.CameraIntegration.startCamera(true)
            }
        },
        capturePhoto () {
            const canvas = document.createElement('canvas')
            const context = canvas.getContext('2d')
            canvas.width = this.$refs.cameraVideo.videoWidth
            canvas.height = this.$refs.cameraVideo.videoHeight
            context.drawImage(this.$refs.cameraVideo, 0, 0, canvas.width, canvas.height)
            this.photo = canvas.toDataURL('image/png')
            this.stopCamera()
        },
        retakePhoto () {
            this.photo = null
            if (Util.isAndroidMode()) {
                window.CameraIntegration.startCamera()
            } else {
                this.startCamera()
            }
        },
        cancelRegistration () {
            this.resetRegistration()
            this.$emit('closeFaceRegistration')
        },
        stopCamera () {
            if (this.stream) {
                this.stream.getTracks().forEach(track => track.stop())
                this.stream = null
            }
            if (Util.isAndroidMode()) {
                window.CameraIntegration.stopCamera()
            }
        },
        resetRegistration () {
            this.stopCamera()
            this.selectedUser = null
            this.selectedUserName = ''
            this.photo = null
            this.photoStep = false
        },
        async savePhoto () {
            if (this.photo) {
                this.images.push(this.photo)
                await this.registerFaceRequest()
            }
        },
        async registerFaceRequest () {
            const id = this.clientCode + '|' + this.consumerCode
            let imagesRegistered = 0
            try {
                for (const image of this.images) {
                    const response = await axios({
                        method: 'post',
                        url: `${API_HOST}/face-register`,
                        data: {
                            face_id: this.clientCode + '|' + this.consumerCode,
                            collection_code: COLLECTION_CODE,
                            image: image
                        },
                        timeout: 12000
                    })
                    if (response && response.status === 200 && response.data && response.data.data && !!response.data.data[id]) {
                        imagesRegistered++
                    }
                }
                const success = imagesRegistered === this.images.length

                if (success) {
                    this.cancelRegistration()
                    Util.showInfoModal(imagesRegistered + ' Rostos registrados com sucesso')
                    return
                }
                Util.showInfoModal('Erro ao registrar ' + (this.images.length - imagesRegistered) + ' rostos')
                this.cancelRegistration()
                return false
            } catch (error) {
                console.error('Erro ao registrar rostos:', error)
                Util.showInfoModal('Erro ao registrar ' + (this.images.length - imagesRegistered) + ' rostos')
                // this.retakePhoto()
            }
        },
        registerImage: async function (base64) {
            /* è enviado uma string com todas as imagens separadas por vírgula */
            const images = base64.split(',')
            for (const img of images) {
                const trimmed = img.trim()
                if (trimmed) {
                    this.images.push(trimmed)
                }
            }
            await this.registerFaceRequest()
        },
        switchActiveInput: function (divReference) {
            this.inputElement = this.$refs[divReference]
            this.isPasswordField = this.inputElement === this.$refs.passwordDiv
        },
        startBarcode: function () {
            this.inputElement = this.$refs.consumerDiv

            if (this.changeConsumerFor !== '') {
                this.rawConsumer = this.changeConsumerFor
            }

            this.switchActiveInput('consumerDiv')
            if (Util.isAndroidMode() && Util.isGertecSk210()) {
                setTimeout(() => {
                    window.GertecBarcodeReader.startDecode(this.ignoreQrCodeSk)
                }, 1000)

                this.gertecBarcodeInterval = setInterval(() => {
                    let readedCode = window.GertecBarcodeReader.getReadedCode()
                    if (readedCode) {
                        this.barCodeInput = readedCode
                        if (this.isTheActiveInput('consumerDiv')) {
                            this.inputElement = this.$refs.consumerDiv
                            this.rawConsumer = this.barCodeInput
                            this.inputElement.innerText = ''
                            this.inputElement.innerText = this.rawConsumer
                            this.barCodeInput = ''
                            if (!this.lockKeyboardCons) {
                                this.switchActiveInput('passwordDiv')
                            }
                        }
                        if (this.isTheActiveInput('passwordDiv')) {
                            this.rawPassword = this.barCodeInput
                            this.inputElement.innerText = ''
                            this.inputElement.innerText = this.rawPassword.replace(/\w/g, '*')
                            this.barCodeInput = ''
                        }
                    }
                }, 1000)
            } else if (!Util.isAndroidMode()) {
                this.barcodeInterval = setInterval(() => {
                    if (document.getElementById('barcodeinput')) {
                        document.getElementById('barcodeinput').focus()
                    }
                }, 500)
            }
        },
        isTheActiveInput: function (divReference) {
            return this.inputElement === this.$refs[divReference]
        },
        passwordCharacterTyped: function (key) {
            this.rawPassword += key
        },
        passwordCharacterErased: function () {
            this.rawPassword = this.rawPassword.slice(0, -1)
        },
        passwordFieldCleaned: function () {
            this.rawPassword = ''
        },
        loginConsumer: async function () {
            this.rawConsumer = this.$refs.consumerDiv.innerText
            let result = this.validateInputs()
            if (result.isValid) {
                this.controlsEnabled = false
                this.$emit('disableOverlayClick')

                let md5Password = this.password === '' ? this.password : md5(this.password)
                let requestObject = {
                    consumerId: this.consumer,
                    password: md5Password,
                    subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
                    storeCode: Util.getGeneralInfo()['storeCode'],
                    lockKeyboardCons: this.lockKeyboardCons ? 'S' : 'N'
                }

                let loginResponse = await requestModule.postRequest('consumer/login', requestObject).then(res => res || {}).catch((e) => {})
                console.log(loginResponse)
                if (!loginResponse || loginResponse.error) {
                    this.controlsEnabled = true
                    this.$emit('enableOverlayClick')
                    if (loginResponse.message) {
                        Util.showInfoModal(loginResponse.message)
                    }
                    return
                }
                this.consumerName = loginResponse.data.consumer.consumerName
                this.consumerId = loginResponse.data.consumer.consumerId
                this.clientCode = loginResponse.data.consumer.clientCode
                this.clientName = loginResponse.data.consumer.clientName
                this.consumerCode = loginResponse.data.consumer.consumerCode || ''
                this.consumerLogin = this.consumer
                this.loggedSuccessfully = true
                this.photoStep = true
                this.startCamera()
            }
        },
        validateInputs: function () {
            let result = {
                isValid: true,
                message: ''
            }

            if (!this.rawConsumer || (!this.rawPassword && !this.lockKeyboardCons)) {
                result.isValid = false
                result.message = this.getString('todos_campos_obrigatorios')
                return result
            }

            this.consumer = this.rawConsumer.trim()
            this.password = this.rawPassword.trim()

            let consumerIsEmpty = this.consumer.length === 0
            let passwordIsEmpty = this.password.length === 0

            if (consumerIsEmpty || (passwordIsEmpty && !this.lockKeyboardCons)) {
                result.isValid = false
                result.message = this.getString('todos_campos_obrigatorios')
                return result
            }
            return result
        }
    },
    created () {
        eventModule.$on('registerImage', this.registerImage)
    },
    beforeDestroy () {
        this.stopCamera()
        eventModule.$off('registerImage')
    }
}
</script>

<style scoped lang='less'>
@import (reference) url("../assets/common.less");

// ===== MODAL BACKDROP =====
.modal-backdrop {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

// ===== MODAL CONTENT =====
.modal-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    width: 85%;
    max-width: 1200px;
    height: 70%;
    max-height: 95%;
    overflow: hidden;
    box-sizing: border-box;

    // ----- MODAL HEADER -----
    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-shrink: 0;

        h2 {
            margin: 0;
        }

        .close-btn {
            background: none;
            border: none;
            font-size: 24px;
            cursor: pointer;
        }
    }

    // ----- MODAL BODY -----
    .modal-body {
        flex: 1;
        margin-top: 15px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        padding: 32px;
        overflow: hidden;
        box-sizing: border-box;

        .message-p {
            font-size: 38px;
            text-align: center;
            color: #333;
        }

        // --- MODAL CONTAINER ---
        .modal-container {
            width: 100%;

            .hidden-input {
                position: fixed;
                margin: -10px 0;
                height: 1px;
                width: 1px;
                width: auto;
                font-size: 1px;
                border: none;
                box-shadow: none !important;
                background-color: rgba(0, 0, 0, 0);
                color: rgba(0, 0, 0, 0);
                z-index: -1;
                outline: none;

                &:focus {
                    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
                    background-color: rgba(0, 0, 0, 0);
                }
            }

            // FORM
            .form {
                margin: 0px 35px;
                height: 300px;
                display: flex;
                flex-direction: column;
                justify-content: center;

                &.lockKeyboardCons {
                    height: 200px;
                }

                .config-item {
                    display: grid;
                    grid-template-columns: 40% 60%;
                    position: relative;

                    &.distance-bottom {
                        margin-bottom: 45px;
                    }

                    .label-container {
                        display: flex;
                        align-items: center;

                        &.disabled-label {
                            pointer-events: none;
                        }

                        label {
                            font-size: 30px;
                            position: relative;
                            display: inline-block;
                            top: 50%;
                            transform: translate(0, -50%);
                            margin: 0;
                        }
                    }

                    .div-input-android {
                        position: relative;
                        display: flex;
                        align-items: center;
                        font-size: 2rem;
                        height: 55px;
                        background-color: white;
                        color: black;
                        border: 2px solid @black;
                        padding: 0 20px;

                        &.active-input {
                            border: 3px solid @primary-color;
                        }

                        &.disabled-input {
                            pointer-events: none;
                            background: rgba(0, 0, 0, 0.1);
                            border: 2px solid lightgray;
                            color: gray !important;
                        }
                    }

                    input {
                        vertical-align: middle;
                        font-size: 2rem !important;
                        padding: 5px 15px;
                        border: 2px solid @primary-color;
                        outline: none;

                        &[type=text] {
                            color: black;
                        }

                        &[type=color] {
                            border: none;
                            height: 100px;
                            width: 100%;
                            box-sizing: inherit;
                            appearance: initial;
                            padding: 0;
                        }
                    }
                }
            }

            // BARCODE INFO
            .barcode-info {
                margin: 10px 50px 50px 50px;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;

                img {
                    width: 300px;
                    height: 150px;
                }

                p {
                    text-align: center;
                    font-size: 28px;
                    margin: 10px;
                }
            }

            // ANDROID KEYBOARD
            #android-keyboard {
                margin: 0px;
            }
        }

        // --- CAMERA ---
        .camera {
            display: flex;
            width: 100%;
            justify-content: center;
            align-items: center;
            background-color: #000;
            margin: 10px 0;
            height: 60%;

            video {
                width: 100%;
                height: 100%;
                object-fit: contain;
                border-radius: 8px;
                flex-grow: 1;
            }
        }

        // --- PHOTO PREVIEW ---
        .photo-preview {
            display: contents;

            img {
                max-width: 100%;
                height: auto;
                border-radius: 8px;
            }
        }
    }

    // ----- MODAL FOOTER -----
    .modal-footer {
        display: flex;
        justify-content: space-around;
        gap: 10px;
        padding: 15px 0 0 0;
        border-top: 1px solid #ddd;
        flex-shrink: 0;
    }
}

// ===== MEDIA QUERIES =====
@media (min-width: 699px) and (max-width: 1025px) {
    .modal-content {
        padding: 10px;
        border-radius: 8px;
        width: 90%;
        max-width: 1200px;
        height: 70%;
        max-height: 95%;

        .modal-header {
            .close-btn {
                font-size: 25px;
            }
        }

        .modal-body {
            flex: 1;
            margin-top: 5px;
            padding: 15px 10px;

            .message-p {
                font-size: 30px;
            }
            // --- CAMERA ---
            .camera {
                display: flex;
                width: 100%;
                height: 50%;
                justify-content: center;
                align-items: center;
                background-color: #000;
                margin: 10px 0;

                video {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                    border-radius: 8px;
                    flex-grow: 1;
                }
            }

            // --- PHOTO PREVIEW ---
            .photo-preview {
                display: contents;

                img {
                    max-width: 100%;
                    height: 50%;
                    border-radius: 8px;
                }
            }
        }
    }
}

@media (max-width: 698px) {
    .modal-content {
        padding: 8px;
        border-radius: 6px;
        width: 95%;
        max-width: 100%;
        height: 75%;
        max-height: 95%;

        .modal-header {
            h2 {
                font-size: 18px;
            }

            .close-btn {
                font-size: 20px;
            }
        }

        .modal-body {
            flex: 1;
            margin-top: 5px;
            padding: 10px 8px;

            .message-p {
                font-size: 20px;
                margin: 5px 0;
            }

            // --- MODAL CONTAINER ---
            .modal-container {
                width: 100%;

                // FORM
                .form {
                    margin: 0px 15px;
                    height: 180px;

                    &.lockKeyboardCons {
                        height: 120px;
                    }

                    .config-item {
                        grid-template-columns: 35% 65%;

                        &.distance-bottom {
                            margin-bottom: 25px;
                        }

                        .label-container {
                            label {
                                font-size: 18px;
                            }
                        }

                        .div-input-android {
                            font-size: 1.3rem;
                            height: 40px;
                            padding: 0 12px;
                            border: 1.5px solid @black;

                            &.active-input {
                                border: 2px solid @primary-color;
                            }

                            &.disabled-input {
                                border: 1.5px solid lightgray;
                            }
                        }

                        input {
                            font-size: 1.3rem !important;
                            padding: 4px 10px;
                            border: 1.5px solid @primary-color;

                            &[type=color] {
                                height: 60px;
                            }
                        }
                    }
                }

                // BARCODE INFO
                .barcode-info {
                    margin: 8px 20px 20px 20px;

                    img {
                        width: 150px;
                        height: 75px;
                    }

                    p {
                        font-size: 16px;
                        margin: 5px;
                    }
                }

                // ANDROID KEYBOARD
                #android-keyboard {
                    margin: 0px;
                    transform-origin: top center;
                }
            }

            // --- CAMERA ---
            .camera {
                display: flex;
                width: 100%;
                height: 45%;
                justify-content: center;
                align-items: center;
                background-color: #000;
                margin: 8px 0;

                video {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                    border-radius: 6px;
                    flex-grow: 1;
                }
            }

            // --- PHOTO PREVIEW ---
            .photo-preview {
                display: contents;

                img {
                    max-width: 100%;
                    height: 45%;
                    border-radius: 6px;
                }

                .message-p {
                    font-size: 18px;
                }
            }
        }

        // ----- MODAL FOOTER -----
        .modal-footer {
            gap: 8px;
            padding: 10px 0 0 0;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/FaceRegistrationModal.vue